import { useEffect, useState } from "react";
import { Link } from "react-router";
import {
  EDITION_BT_LINK,
  EDITION_BTG_LINK,
} from "@features/banner/Edition/utils/constants";
import { cn } from "@util/helpers";
import Cookies from "js-cookie";
import { useFeatureFlagEnabled } from "posthog-js/react";

type EditionProps = {
  /** This is the classname of the component. */
  className?: string;
  /** Flag to show/hide label. */
  showLabel?: boolean;
  /** Flag to check sg user. */
  isGeoSg?: boolean;
};

/** This is the edition switcher component. */
const Edition = ({
  className,
  showLabel = false,
  isGeoSg,
}: EditionProps): React.ReactElement => {
  const [isSgPreferred, setIsSgPreferred] = useState<boolean>(true);

  const isOverwritten = useFeatureFlagEnabled(
    "feature_overwrite_condition_edition"
  );

  const handleSG = () => {
    if (typeof window === "undefined") return;

    Cookies.set("preferred_region", "SG");
  };

  const handleNONSG = () => {
    if (typeof window === "undefined") return;

    Cookies.set("preferred_region", "NONSG");
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const userPreferredVersion = Cookies.get("preferred_region");
    if (userPreferredVersion === "SG") return;
    setIsSgPreferred(false);
  }, []);

  if (isGeoSg && !isOverwritten) return <></>;

  const linkParams = new URLSearchParams({
    ref: "global-masterhead",
  });

  const params = `?${linkParams?.toString()}`;

  return (
    <div
      data-testid="edition-component"
      className={cn(
        "w-full font-poppins text-4xs font-medium tracking-tightest text-gray-550",
        className
      )}
    >
      {showLabel ? (
        <p className="mb-0 text-2xs font-semibold uppercase text-gray-350">
          CHOOSE EDITION
        </p>
      ) : null}

      <div
        className={cn("flex flex-row items-center justify-center gap-2", {
          "mt-2 justify-start gap-1 rounded-[4px] bg-gray-150 p-1": showLabel,
        })}
      >
        <Link
          to={`${EDITION_BT_LINK}${params}`}
          className={cn(
            "flex items-center justify-center text-gray-515 hover:underline",
            {
              "flex-1 rounded-[4px] py-3 text-center text-2xs hover:no-underline lg:py-2  lg:leading-1.6":
                showLabel,
              "bg-white font-semibold text-gray-850": isSgPreferred,
            }
          )}
          onClick={handleSG}
        >
          Singapore
        </Link>

        <Link
          to={`${EDITION_BTG_LINK}${params}`}
          className={cn(
            "flex items-center justify-center border-l border-gray-175 pl-2 hover:underline",
            {
              "flex-1 rounded-[4px] border-none py-3 pl-0 text-center text-2xs text-gray-515 hover:bg-white hover:no-underline lg:py-2 lg:leading-1.6":
                showLabel,
              "bg-white font-semibold text-gray-850": !isSgPreferred,
            }
          )}
          onClick={handleNONSG}
        >
          Global
        </Link>
      </div>
    </div>
  );
};

export default Edition;
